/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system';
import { PROMETHEAN_TEXT_HEADER, PROMETHEAN_NEUTRAL_WHITE, PROMETHEAN_TEXT, PROMETHEAN_BLUE } from '../styles/colors/colors';
import { PROMETHEAN_SPACER_LG } from '../styles/typography/spacer';
export var TitleContainer = styled('div')({
  '&.EmbersTitle-root': {
    display: 'flex',
    '&.EmbersTitle-pageTitle': {
      padding: '24px 0px',
      justifyContent: 'space-between',
      '.EmbersTitle-title': {
        color: PROMETHEAN_TEXT_HEADER
      },
      '.EmbersTitle-titleContainer': {
        display: 'flex',
        alignItems: 'center',
        width: 0,
        flex: 1,
        '.EmbersTitle-back': {
          cursor: 'pointer',
          color: PROMETHEAN_TEXT,
          marginRight: 8,
          '&:focus-visible': {
            outline: "2px solid ".concat(PROMETHEAN_BLUE),
            outlineOffset: -2 // The outline should be inside the box of icon
          }
        },
        '.EmbersTitle-postfix': {
          marginLeft: 8
        }
      },
      '.EmbersTitle-actionContainer': {
        minHeight: 40,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        marginLeft: 24,
        columnGap: 10,
        rowGap: 10,
        flexShrink: 0,
        '&.EmbersTitle-actionContainer-column': {
          flexDirection: 'column',
          alignItems: 'flex-start',
          marginLeft: 0
        }
      },
      '&.EmbersTitle-column': {
        flexDirection: 'column'
      }
    },
    '&.EmbersTitle-appTitle': {
      padding: "20px ".concat(PROMETHEAN_SPACER_LG),
      background: PROMETHEAN_NEUTRAL_WHITE,
      '.EmbersTitle-title': {
        color: PROMETHEAN_TEXT_HEADER,
        letterSpacing: '0.02em'
      }
    },
    '.EmbersTitle-titleContainer': {
      '.EmbersTextTooltip-root': {
        '.EmbersTypography-root': {
          flex: 'initial',
          width: 'auto'
        }
      }
    },
    '&.EmbersTitle-column': {
      '.EmbersTitle-titleContainer': {
        '.EmbersTextTooltip-root': {
          minWidth: 'fit-content',
          '.EmbersTypography-root': {
            width: 'max-content'
          }
        }
      }
    },
    '&.EmbersTitle-touchDevice': {
      '&.EmbersTitle-secondary': {
        '.EmbersTitle-title': {
          letterSpacing: '0.02em'
        },
        '&.EmbersTitle-hasTooltip': {
          '.EmbersTitle-titleContainer': {
            paddingRight: 24
          }
        }
      }
    }
  }
});